import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import baseInfo from './modules/base-info';
import pageInfo from './modules/page-info';
import station from './modules/station';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user,
        baseInfo,
        pageInfo,
        station
    }
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js